import React from 'react';
import { Translate } from 'react-redux-i18n';
import get from 'lodash.get';
import { ViewTable } from '../layouts/viewTable';
import { ViewSectionRow } from '../layouts/viewSectionRow';
import LabeledImage from '../common/LabeledImage';
import { getImagePath } from '../../helpers/imageUrlHelper';
import { UrlWithCopy } from '../common/UrlWithCopy';
import { getAboutText } from '../../helpers/pageAboutHelper';
import CurrencyHelper from '../../helpers/currencyHelper';

interface Props { entity: any; isShowEmptyFields: boolean; translationBase: string; }
export const PageEntityAbout: React.FC<Props> = ({ entity, isShowEmptyFields, translationBase }) => {
  const dataTemplate = get(entity,'template.value.about');
  const targetAmount = get(entity,'targetAmount');
  const organization = get(entity,'organization') || get(entity,'campaign.organization');
  const manager = get(entity,'manager');
  const team = get(entity,'team');
  const collection = get(entity,'collection');
  const about = getAboutText(
    dataTemplate,
    targetAmount,
    organization?.name,
    manager?.firstName,
    team?.name,
    collection?.name,
    null,
    CurrencyHelper.getCurrencySymbol(organization?.currency)
  );
  const shortDescription = about?.elements?.find((e: any) => e.type === 'text')?.value || '';
  const pageImage = about?.elements?.find((e: any) => e.type === 'image')?.value || '';
  const pageImageUrl = pageImage ? getImagePath(pageImage) : null;
  const mainImageUrl = get(entity,'mainImageUrl');
  const videoUrl = about?.elements?.find((e: any) => e.type === 'video')?.value || '';
  const name = get(entity,'name');
  const campaignImageUrl = get(entity,'campaign.mainImageUrl');
  const organizationImageUrl = get(organization,'mainImageUrl');
  const fallbackImageUrls = [campaignImageUrl, organizationImageUrl].filter(Boolean) as string[];
  const hasContent = shortDescription || mainImageUrl || videoUrl;
  if (!hasContent && !isShowEmptyFields) return null;
  return (
    <div className="page-entity-about">
      <ViewTable title={<Translate value={`${translationBase}.short-description.title`} />}>
        <LabeledImage imageUrl={mainImageUrl} fallbackImageUrls={fallbackImageUrls} labelTranslationKey={`${translationBase}.short-description.main-image`} altText={name} size="small" shape="rounded" />
        <ViewSectionRow title={`${translationBase}.short-description.description`} data={shortDescription} isShowEmptyFields={isShowEmptyFields} />
        <LabeledImage imageUrl={pageImageUrl || undefined} labelTranslationKey={`${translationBase}.short-description.page-image`} altText={name} size="small" shape="rounded" />
        <ViewSectionRow title={`${translationBase}.short-description.video-url`} data={videoUrl ? <UrlWithCopy url={videoUrl} /> : null} isShowEmptyFields={isShowEmptyFields} />
      </ViewTable>
    </div>
  );
};
export default PageEntityAbout;
